<template>
  <div class="index">
    <!-- <div class="homebg" /> -->
    <a-carousel arrows>
      <div
        slot="prevArrow"
        class="custom-slick-arrow"
        style="left: 10px; zindex: 1"
      >
        <a-icon type="left-circle" />
      </div>
      <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
        <a-icon type="right-circle" />
      </div>
      <img class="homebg" src="../../assets/image/banner5.png" alt="" />
      <!-- <img
        class="homebg"
        v-for="(item,index) in imgList"
        :key="index"
        :src="item.url"
        alt=""
      > -->
    </a-carousel>
    <div class="navbar">
      <div>
        <div class="list" @click="handleTab('1F')">
          <img src="../../assets/image/ico产品服务.png" alt="" />
          <span>产品服务</span>
        </div>
      </div>
      <div>
        <div class="list" @click="$router.push('./industryTrends')">
          <img src="../../assets/image/ico生态服务.png" alt="" />
          <span>行业动态</span>
        </div>
      </div>
      <!--<div>
        <img
          src="../../assets/image/ico行业服务.png"
          alt=""
        >
        <span>行业服务</span>
      </div>
       <div>
        <img
          src="../../assets/image/ico生态服务.png"
          alt=""
        >
        <span>生态服务</span>
      </div>
      <div>
        <img
          src="../../assets/image/ico移动信息化服务.png"
          alt=""
        >
        <span>移动信息化服务</span>
      </div>
      <div>
        <img
          src="../../assets/image/ico专业平台搭建服务.png"
          alt=""
        >
        <span>专业平台搭建服务</span>
      </div> -->
      <div>
        <div class="list" @click="$router.push('./advantage')">
          <img src="../../assets/image/ico行业服务.png" alt="" />
          <span>我们的优势</span>
        </div>
      </div>
      <div>
        <div class="list" @click="$router.push('./contact')">
          <img src="../../assets/image/ico风险咨询服务.png" alt="" />
          <span>联系我们</span>
        </div>
      </div>
    </div>
    <div id="1F" class="index-apply">
      <div class="tit">
        <div class="title">
          <span class="tit-text">保函业务</span>
        </div>
        <span class="tit-con">对接多家公共资源交易中心和政府采购平台</span>
      </div>
      <div class="applyList">
        <!-- :class="isOpen?'showStyle':''" -->
        <div class="apply-list">
          <img src="../../assets/image/投标保函.png" alt="" />
          <div class="list-tit">投标保函</div>
          <div class="list-text">
            投标保函是指：在招标投标中由保证人（银行或担保公司）为投标人向招标人提供的、保
            证投标人按照招标文件的规定参加招标活动的保函。投标人在投标有效期内撤回投标文件，
            或中标后不签署工程建设合同的，由保证人按照约定履行保证责任。
          </div>
          <div class="list-btn">
            <a-button type="primary" @click="$router.push('./bidSecurity')">
              立即申请
            </a-button>
          </div>
        </div>
        <div class="apply-list">
          <img src="../../assets/image/履约保函.png" alt="" />
          <div class="list-tit">履约保函</div>
          <div class="list-text">
            履约保函是指：应劳务方和承包方（申请人）的请求，银行金融机构向工程的业主方（招标
            人）做出的一种履约保证承诺。如果劳务方和承包方日后未能按时、按质、按量完成其所承
            建的工程，则银行将向业主方支付保函约定款项，履约保函有一定的格式限制，也有一定的
            条件。
          </div>
          <div class="list-btn">
            <a-button type="primary" @click="$router.push('./performStep')">
              立即申请
            </a-button>
          </div>
        </div>
        <div class="apply-list">
          <img src="../../assets/image/预付款保函.png" alt="" />
          <div class="list-tit">预付款保函</div>
          <div class="list-text">
            预付款保函是指：承包人要求银行向业主(发包人)出具的保证业主所支付的工程预付款用
            于实施项目的一种信用函件。投标人在中标后签订的合同中规定，承包人委托银行向业主出
            具的由业主按合同规定向承包人支付一笔工程预付款，及时用于实施项目的保证函件。担保
            银行应为业主所接受。如承包人不履约，业主可凭保函向担保银行索赔。
          </div>
          <div class="list-btn">
            <a-button type="primary" @click="$router.push('./advanceCharge')">
              立即申请
            </a-button>
          </div>
        </div>
        <div class="apply-list" v-if="isOpen">
          <img src="../../assets/image/质量保函.png" alt="" />
          <div class="list-tit">质量保函</div>
          <div class="list-text">
            质量保函，也称为“维修保函”，是指应供货方或承建人申请，向买方或业主保证，如货物
            或工程的质量不符合合同约定而卖方或承建人又不能依约更换或修理时，按买方或业主的索
            赔予以赔偿的书面文件。
          </div>
          <div class="list-btn">
            <a-button type="primary" @click="$router.push('./quality')">
              立即申请
            </a-button>
          </div>
        </div>
        <div class="apply-list" v-if="isOpen">
          <img src="../../assets/image/农民工工资保函.png" alt="" />
          <div class="list-tit">农民工工资保函</div>
          <div class="list-text">
            总承包单位、业主等企业的申请开立，按照《保障农民工工资支付条例》要求可用以替代工
            资保证金的保函。
          </div>
          <div class="list-btn">
            <a-button type="primary" @click="$router.push('./migrantWorkers')">
              立即申请
            </a-button>
          </div>
        </div>
        <!-- <div
          class="apply-list"
        >
          <div class="list-tit tits">
            保费概算
          </div>
          <a-form-model
            :model="form"
            :label-col="{xs: { span: 24 },sm: { span: 8 }}"
            :wrapper-col="{xs: { span: 24 },sm: { span: 12 }}"
          >
            <a-form-model-item
              label="保函类型"
              prop="insureType"
            >
              <a-select
                v-model="form.insureType"
                style="width: 120px"
              >
                <a-select-option
                  v-for="(item,index) in typeList"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              label="保证期限(天)"
              prop="insureLimit"
            >
              <a-input v-model="form.insureLimit" />
            </a-form-model-item>
            <a-form-model-item
              label="保证金额"
              class="index-money"
              prop="insureAmount"
            >
              <div style="display:flex;">
                <a-input v-model="form.insureAmount" />
                <a-button
                  type="link"
                  @click="getComputed"
                >
                  概算
                </a-button>
              </div>
            </a-form-model-item>
            <a-form-model-item
              label="金额概算(元)"
              prop="result"
            >
              <a-input v-model="form.result" />
            </a-form-model-item>
            <div style="color:red;display: flex;justify-content: center;">
              *实际需支付金额以实际审核后显示为准
            </div>
            <a-form-model-item class="indexBtn">
              <a-button
                type="primary"
                @click="onSubmit"
              >
                立即申请
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div> -->
      </div>
      <div style="display: flex; justify-content: center; margin: 30px 0 0">
        <a-button style="width: 115px" type="primary" @click="isOpen = !isOpen">
          {{ isOpen ? "收起" : "查看更多产品" }}
        </a-button>
      </div>
    </div>
    <div class="index-about">
      <div class="tit">
        <div class="title">
          <span class="tit-text">关于我们</span>
        </div>
        <span class="tit-con">对接多家公共资源交易中心和政府采购平台</span>
      </div>
      <div class="about">
        <div class="about-left">
          <img src="../../assets/image/about.png" alt="" />
        </div>
        <div class="about-right">
          <div class="text">
            甘肃省融资担保集团股份有限公司（简称“担保集团”）成立于2012年2月，注册资本50亿元，是由甘肃省公路航空旅游投资集团有限公司、甘肃省金融资本管理有限公司出资设立的省内资本规模最大、担保实力最强的市场化国有担保机构。连续5年获得中诚信国际、联合资信、东方金诚等6家市场权威评级机构授予的行业最高等级——AAA主体信用评级，增信实力位居全国担保行业第一梯队。
          </div>
          <div class="text">
            担保集团始终践行服务实体经济的初心使命，在服务大局中彰显国企担当，持续为区域经济的繁荣发展贡献担保力量，获得了政府、行业、客户的广泛高度认可。曾获得由国家工信部、财政部专项奖补资金6000万元，额度位居全国同行业第一；先后八次荣获“省长金融奖”，在全国担保行业开展的优秀担保机构评选活动中，被评为“最具影响力担保机构”和“最具创新力担保机构”；自主研发的“增信保”产品在第二届“陇上金融家”评选活动中荣获“甘肃最佳金融产品和服务”奖项。
          </div>
          <div class="text">
            担保集团内设11个部门，下设4家子公司和10家分公司，业务机构覆盖甘肃全省，并在陕西省设立省外机构。自成立以来，与多家头部券商、大型投资机构建立了良好合作关系，累计为1万余户市场主体提供各类融资服务近680亿元。债券担保业务立足甘肃、辐射全国，业务布局已覆盖陕、川、渝、苏、湘、鄂、鲁等地；持续强化金融科技赋能，成功签发省内首笔电子投标保函，非融保函业务市场占有率稳居省内第一；以专业、高效的金融服务赢得业界赞誉，品牌影响力不断提升。
          </div>

          <a-button type="link" @click="$router.push('./brandintroduction')">
            查看更多
          </a-button>
        </div>
      </div>
    </div>
    <div class="index-company">
      <div class="tit">
        <div class="title">
          <span class="tit-text">合作伙伴</span>
        </div>
        <span class="tit-con">对接多家公共资源交易中心和政府采购平台</span>
      </div>
      <div class="company">
        <!-- <img
          v-for="(item,index) in imgList"
          :key="index"
          :src="item.url"
          alt=""
        > -->
        <img src="../../assets/img/img1.png" alt="" />
        <img src="../../assets/img/img2.png" alt="" />
        <img src="../../assets/img/img3.png" alt="" />
        <img src="../../assets/img/img4.png" alt="" />
        <img src="../../assets/img/img5.png" alt="" />
        <img src="../../assets/img/img6.png" alt="" />
        <img src="../../assets/img/img7.png" alt="" />
        <img src="../../assets/img/img8.png" alt="" />
        <img src="../../assets/img/img9.png" alt="" />
        <img src="../../assets/img/img10.png" alt="" />
        <img src="../../assets/img/img11.png" alt="" />
        <img src="../../assets/img/img12.png" alt="" />
      </div>
    </div>
    <div class="index-block">
      <div class="top">
        <span>联系我们</span>
      </div>
      <div class="bottom">
        <div>
          <div>电话：0931-8803399</div>
          <div>传真：0931-8803399</div>
          <div>邮箱：gsrzdbao@163.com</div>
        </div>
        <div>
          <span>地址：兰州市城关区东岗西路621号长业金座18-21层</span>
        </div>
      </div>
      <!-- <div class="bottom">
        <span>邮箱地址：ysdb@eptok.com</span>
        <span>邮政编码：518000</span>
        <span />
      </div> -->
    </div>
  </div>
</template>
<script>
import { dictDetail } from "@/api/performance.js";
import { calculate } from "@/api/index.js";
export default {
  data() {
    return {
      isOpen: false,
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: {
        insureType: "",
        insureLimit: "",
        insureAmount: "",
        result: "",
      },
      typeList: [],
      imgList: [
        { url: "../../assets/image/banner5.png" },
        { url: "../../assets/image/banner5.png" },
      ],
    };
  },
  mounted() {
    window.localStorage.setItem("current", "['1']");
    this.getDictDetail();
  },
  methods: {
    handleTab(type) {
      this.current = type;
      const div = document.getElementById(type);
      if (div) {
        div.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
    getDictDetail() {
      dictDetail({ dictName: "insureType" }).then((res) => {
        this.typeList = res.data.data;
      });
    },
    getComputed() {
      calculate({ ...this.form }).then((res) => {
        this.form.result = res.data.data.result;
        window.localStorage.setItem("result", this.form.result);
      });
    },
    onSubmit() {
      console.log(this.form, "this.form");
    },
  },
};
</script>
<style lang="less" scoped>
.homebg {
  width: 100%;
  height: 560px;
  // background: url("../../assets/image/banner5.png") no-repeat center;
}
.navbar {
  width: 1180px;
  height: 120px;
  background: #ffffff;
  box-shadow: 0px 0px 28px 2px rgba(216, 224, 233, 0.6);
  margin: 0 auto;
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 660px;
  transform: translate(-50%, -50%);
  div {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .list {
      cursor: pointer;
      img {
        width: 40px;
        height: 40px;
        margin-bottom: 14px;
      }
      span {
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
.index-apply {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  margin: 40px 0;
  padding-top: 120px;
}
.index-about {
  margin: 0 auto 50px;
  padding-top: 40px;
  .about {
    display: flex;
    justify-content: center;
    padding-top: 60px;
    .about-left {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
      }
    }
    .about-right {
      position: relative;
      .text {
        text-align: justify;
        margin-left: 130px;
        width: 720px;
        text-indent: 2em;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666;
        line-height: 36px;
      }
      ::v-deep .ant-btn {
        position: absolute;
        right: 0;
        bottom: -20px;
        width: 96px;
        height: 40px;
        border: 1px solid #ddd;
        border-radius: 20px;
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999;
        background-color: #fff;
        cursor: pointer;
        transition: all 0.5s;
      }
    }
  }
}
.index-company {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f4f5f6;
  padding-top: 60px;
  .company {
    margin: 70px 0 90px;
    width: 1200px;
    img {
      margin: 20px 10px;
      // width: 180px;
      // height: 60px;
      width: 180px;
      height: 55px;
      border: 1px solid #dadada;
      padding: 10px;
    }
  }
}
.index-block {
  background: url("../../assets/image/bg-footer.png") no-repeat center;
  height: 240px;
  padding: 48px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .top {
    width: 1178px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;
    span {
      font-size: 1.5rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    width: 1178px;
    margin-bottom: 18px;
    div {
      flex: 1;
      font-size: 0.875rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 5px;
    }
  }
}
.index-money {
  .ant-input {
    width: 150px !important;
  }
}
.applyList {
  width: 70%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 60px;
}
.apply-list {
  position: relative;
  width: 380px;
  height: 475px;
  background: #ffffff;
  box-shadow: 0px 8px 18px 2px rgba(136, 161, 188, 0.18);
  border-radius: 8px;
  padding: 40px 50px;
  margin: 0 10px 30px;
  transition: all 0.5s;
  img {
    width: 100%;
    margin-bottom: 10px;
  }
}
.apply-list:hover {
  transition: all 0.5s;
  box-shadow: 0px 6px 30px 0px rgba(115, 139, 165, 0.4);
}
.list-tit {
  font-size: 18px;
  font-weight: 800;
  margin: 10px 0;
}
.list-text {
  box-sizing: border-box;
}
.list-btn {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.indexBtn {
  ::v-deep .ant-form-item-control {
    left: 65%;
    top: 44px;
  }
}
.tits {
  margin: 10px 205px 10px 0;
}
.tit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 62px;
    height: 30px;
    border-bottom: 6px solid #ec6941;
    .tit-text {
      z-index: 1;
      font-size: 2rem;
      font-family: Microsoft YaHei;
      font-weight: 700;
      color: #333;
      white-space: nowrap;
    }
  }
  .tit-con {
    font-size: 1.25rem;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #999;
  }
}
.showStyle {
  margin-right: 100px;
}
::v-deep .ant-input,
.ant-select {
  width: 200px !important;
}
::v-deep .ant-form-item-label {
  text-align: left;
}
::v-deep .ant-btn-primary {
  width: 96px;
  height: 40px;
  border: 1px solid #dddddd;
  border-radius: 20px;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.5s;
}
::v-deep .ant-btn-primary:hover {
  border: 1px solid #2e4e9a;
  color: #2e4e9a;
  transition: all 0.5s;
}
</style>
<style scoped>
/* For demo */
.ant-carousel >>> .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}
</style>
